<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        :title="title"
        :height="height"
        :embedded="embedded"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/BomSheet/CoreBomSheetDetail"
        :parent-component="$options.name"
        :main-validator="mainValidator"
        :row-background="rowBackground"
        @embedded_action="$emit('embedded_action', $event)"
    >
      <template v-slot:item.qty="{item}">
        <span :style="{color: item.designator_error ? 'red' : null}">{{ item.qty }}</span>
      </template>
      <template v-slot:item.supply_type="{item}">
        <slot name="item.supply_type" :item="item"></slot>
      </template>
      <template v-slot:item.provider_uid="{ item }">
        <span v-if="!!item.provider_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.provider_uid]">
          {{ storeAggregate.rootData[item.provider_uid].name }}
        </span>
      </template>
      <template v-slot:item.customer_order__name="{ item }">
        <span
            v-if="!!item.customer_order_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.customer_order_uid]">
          {{ storeAggregate.rootData[item.customer_order_uid].name }}
        </span>
      </template>
      <template v-slot:item.customer_order__product__name="{ item }">
        <span v-if="!!item.customer_order_uid && !!storeAggregate.rootData &&
        !!storeAggregate.rootData[item.customer_order_uid] &&
        !!storeAggregate.rootData[item.customer_order_uid].product_uid &&
        !!storeAggregate.rootData[storeAggregate.rootData[item.customer_order_uid].product_uid]">
          {{ storeAggregate.rootData[storeAggregate.rootData[item.customer_order_uid].product_uid].name }}
        </span>
      </template>
      <template v-slot:item.customer_order__product__article_number="{ item }">
        <span v-if="!!item.customer_order_uid && !!storeAggregate.rootData &&
        !!storeAggregate.rootData[item.customer_order_uid] &&
        !!storeAggregate.rootData[item.customer_order_uid].product_uid &&
        !!storeAggregate.rootData[storeAggregate.rootData[item.customer_order_uid].product_uid]">
          {{ storeAggregate.rootData[storeAggregate.rootData[item.customer_order_uid].product_uid].article_number }}
        </span>
      </template>
      <template v-slot:item.customer_order__customer__name="{ item }">
        <span v-if="!!item.customer_order_uid && !!storeAggregate.rootData &&
        !!storeAggregate.rootData[item.customer_order_uid] &&
        !!storeAggregate.rootData[item.customer_order_uid].customer_uid &&
        !!storeAggregate.rootData[storeAggregate.rootData[item.customer_order_uid].customer_uid]">
          {{ storeAggregate.rootData[storeAggregate.rootData[item.customer_order_uid].customer_uid].name }}
        </span>
      </template>
      <template v-slot:item.customer_order__customer__alias="{ item }">
        <span v-if="!!item.customer_order_uid && !!storeAggregate.rootData &&
        !!storeAggregate.rootData[item.customer_order_uid] &&
        !!storeAggregate.rootData[item.customer_order_uid].customer_uid &&
        !!storeAggregate.rootData[storeAggregate.rootData[item.customer_order_uid].customer_uid]">
          {{ storeAggregate.rootData[storeAggregate.rootData[item.customer_order_uid].customer_uid].alias }}
        </span>
      </template>
      <template v-slot:item.component_edit="{ item }">
        <v-icon
            v-if="!!item.component_uid && !!detailStoreComponent"
            small @click="detailStoreComponent.openDetailDialog({item: null, uid: item.component_uid})"
            color="edit_icon" class="d-flex justify-center">
          mdi-pencil-outline
        </v-icon>
      </template>
      <template v-slot:item.component_search="{ item }">
        <v-row v-if="!!item.mpn || !!item.description">
          <v-btn
              x-small
              text
              icon
              color="blue lighten-2"
              @click="onClickSearchOctopart(item.mpn || item.description)"
              class="ml-9"
          >
            <v-img height="10" width="70" contain src="/static/images/mpnresearch/octopart.svg"></v-img>
          </v-btn>
        </v-row>
        <v-row v-if="!!item.mpn || !!item.description">
          <v-btn
              x-small
              text
              icon
              color="blue lighten-2"
              @click="onClickSearchGoogle(item.mpn || item.description)"
              class="ml-9"
          >
            <v-img height="12" width="50" contain src="/static/images/mpnresearch/google.svg"></v-img>
          </v-btn>
        </v-row>
      </template>
      <template v-slot:item.attributes_checked="{ item }">
        <slot name="item.attributes_checked" :item="item">
          <v-icon small v-if="item.attributes_checked" color="green">mdi-check-bold</v-icon>
        </slot>
      </template>
      <template v-slot:item.descriptions_match="{ item }">
        <span v-for="desc_match of item.descriptions_match">
          <span v-if="desc_match.match" style="color: blue">{{ desc_match.value }}</span>
          <span v-else style="color:red">{{ desc_match.value }}</span>
        </span>
        {{''}}
      </template>
      <template v-slot:item.main_attributes_match="{ item }">
        <span v-for="(desc_match, index) in item.main_attributes_match">
          <span v-if="index !== 0"> • </span>
          <span v-if="desc_match.match" style="color: blue">{{ desc_match.value }}</span>
          <span v-else style="color:red">{{ desc_match.value }}</span>
        </span>
        {{''}}
      </template>
      <template v-slot:item.component__alias="{ item }">
<!--        <v-chip-->
<!--            v-if="!!item.component_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.component_uid]"-->
<!--            @click="detailStoreComponent.openDetailDialog({item: null, uid: item.component_uid})"-->
<!--            :color="status_article_color(item)"-->
<!--        >-->
<!--          {{ storeAggregate.rootData[item.component_uid].alias }}-->
<!--        </v-chip>-->
        <v-chip
            v-if="!!item.component_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.component_uid]"
            @click="onComponentClick(item.component_uid)"
            :color="status_article_color(item)"
        >
          {{ storeAggregate.rootData[item.component_uid].alias }}
        </v-chip>
        <v-icon
            v-if="!!item.component_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.component_uid]"
            @click="onClickOctopart(item)"
            color="blue lighten-2">mdi-cog
        </v-icon>
      </template>
      <template v-slot:item.component__article="{ item }">
<!--        <v-chip-->
<!--            v-if="!!item.component_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.component_uid] &&-->
<!--            !!storeAggregate.rootData[item.component_uid].article_display"-->
<!--            @click="detailStoreComponent.openDetailDialog({item: null, uid: item.component_uid})"-->
<!--            :color="status_article_color(item)"-->
<!--        >-->
<!--          {{ storeAggregate.rootData[item.component_uid].article_display }}-->
<!--        </v-chip>-->
        <v-chip
            v-if="!!item.component_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.component_uid] &&
            !!storeAggregate.rootData[item.component_uid].article_display"
            @click="onComponentClick(item.component_uid)"
            :color="status_article_color(item)"
        >
          {{ storeAggregate.rootData[item.component_uid].article_display }}
        </v-chip>
      </template>
      <template v-slot:item.component__case_package__type="{ item }">
        <v-chip
            v-if="!!item.component_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.component_uid] &&
            !!storeAggregate.rootData[item.component_uid].case_package_uid &&
            !!storeAggregate.rootData[storeAggregate.rootData[item.component_uid].case_package_uid].case_package_type"
            :color="storeAggregate.rootData[storeAggregate.rootData[item.component_uid].case_package_uid].case_package_type_color_dict.color"
        >
          {{
            storeAggregate.rootData[storeAggregate.rootData[item.component_uid].case_package_uid].case_package_type_color_dict.text
          }}
        </v-chip>
      </template>
      <template v-slot:item.component__case_package__name="{ item }">
        <v-chip
            v-if="!!item.component_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.component_uid] && !!storeAggregate.rootData[item.component_uid].case_package_uid"
            :color="storeAggregate.rootData[storeAggregate.rootData[item.component_uid].case_package_uid].color"
        >
          {{ storeAggregate.rootData[storeAggregate.rootData[item.component_uid].case_package_uid].name }}
        </v-chip>
      </template>
      <template v-slot:item.component__subcategory__category__category="{ item }">
        <span v-if="!!item.component_uid && storeAggregate.rootData && !!storeAggregate.rootData[item.component_uid] &&
        !!storeAggregate.rootData[item.component_uid].subcategory_uid &&
        !!storeAggregate.rootData[storeAggregate.rootData[item.component_uid].subcategory_uid] && !!storeAggregate.rootData[storeAggregate.rootData[item.component_uid].subcategory_uid].category_uid">
          {{
            storeAggregate.rootData[storeAggregate.rootData[storeAggregate.rootData[item.component_uid].subcategory_uid].category_uid].category
          }}
        </span>
      </template>
      <template v-slot:item.component__image="{ item }">
        <BaseImageCard
            v-if="!!component_property(item, 'image')"
            :value="component_property(item, 'image')"
            :max-height="40"
            :max-width="64"
            readonly
        >
        </BaseImageCard>
      </template>
      <template v-slot:item.component__datasheet="{ item }">
        <v-icon
            v-if="!!component_property(item, 'datasheet')"
            @click="onClickDataSheet(item)"
            color="blue lighten-2">
          mdi-file-pdf-box
        </v-icon>
      </template>
      <template v-slot:footer.middle>
        <v-chip v-if="!!storeTable && !!storeTable.common && !!storeTable.common.data" label class="mx-1">
          {{ $t('smd_on_page') }} = {{ storeTable.common.data.smd_quantity }}
        </v-chip>
        <v-chip v-if="!!storeTable && !!storeTable.common && !!storeTable.common.data" label class="mx-1">
          {{ $t('tht_on_page') }} = {{ storeTable.common.data.tht_quantity }}
        </v-chip>
        <v-chip v-if="!!storeTable && !!storeTable.common && !!storeTable.common.data" label class="mx-1">
          {{ $t('dnp_on_page') }} = {{ storeTable.common.data.dnp_quantity }}
        </v-chip>
      </template>
    </CommonTable>
    <v-dialog
        v-if="!!detailStoreComponent"
        ref="detailComponentDialog"
        v-model="detailStoreComponent.dialogDetail"
        persistent
        scrollable
    >
      <ComponentDetail
          :uid-item="detailStoreComponent.uidItem"
          :store-name="detailStoreComponentName"
          :modalDialog="true"
          :route-full-screen="{name: 'ComponentDetail', params: {itemUid: detailStoreComponent.uidItem}}"
          :main-validator="true"
          :embedded="embedded"
      ></ComponentDetail>
    </v-dialog>
  </v-container>
</template>

<script>
import {v4 as uuidv4} from "uuid";
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreBomSheetDetail from "@/components/CoreComponent/BomSheet/CoreBomSheetDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import CommonFieldText from "@/components/Common/CommonFieldText";
import BaseImageCard from "@/components/Base/BaseImageCard";
import ComponentDetail from "@/components/CoreComponent/Component/ComponentDetail";
import {useDetailStore} from "@/components/Common/CommonDetail";

export default {
  name: "CoreBomSheetTable",

  props: {
    height: {default: null},
    title: {default: 'BomSheet'},
    embedded: {default: false},
    headers: {default: null},
    storeName: {type: [String], default: 'CoreBomSheetTable'},
    dtoDetailQuery: {default: 'BomSheetDetailQueryDTO'},
    detailStoreName: {default: 'BomSheetDetail'},
    dtoValidateCommand: {type: [String], default: 'BomSheetValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'BomSheetListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'BomSheetActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
    rowBackground: {
      type: [Function], default(item) {
        return item.item_color
      }
    },
  },

  components: {
    ComponentDetail,
    CommonTable,
    CoreBomSheetDetail,
    BaseFieldCheck,
    CommonFieldText,
    BaseImageCard,
  },

  methods: {
    onComponentClick(component_uid) {
      if (component_uid) {
        const routeData = this.$router.resolve({name: 'ComponentDetail', params: {uidItem: component_uid}});
        window.open(routeData.href, '_blank');
      }
    },
    component_property(item, property_name) {
      if (!!item.component_uid && this.storeAggregate.rootData && !!this.storeAggregate.rootData[item.component_uid])
        return this.storeAggregate.rootData[item.component_uid][property_name]
      return null
    },
    onClickDataSheet(item) {
      window.open(this.component_property(item, 'datasheet'), '_blank')
    },
    onClickOctopart(item) {
      window.open(this.component_property(item, 'source_url'), '_blank')
    },
    onClickSearchOctopart(search) {
      window.open('https://octopart.com/search?currency=EUR&specs=0&q=' + search, '_blank')
    },
    onClickSearchGoogle(search) {
      window.open('https://www.google.com/search?newwindow=1&q=' + search, '_blank')
    },
    status_article_color(item) {
      if (!item.component_uid || !this.storeAggregate.rootData || !this.storeAggregate.rootData[item.component_uid])
        return null
      if (this.storeAggregate.rootData[item.component_uid].row_statuses.error_status === 'SUCCESS')
        return 'light-green lighten-4'
      if (this.storeAggregate.rootData[item.component_uid].row_statuses.error_status === 'WARNING')
        return 'amber lighten-4'
      if (this.storeAggregate.rootData[item.component_uid].row_statuses.error_status === 'ERROR')
        return 'pink lighten-4'
      return null
    },
  },

  mounted() {
    this.storeAggregate = useAggregateStore()
    this.detailStoreComponent = useDetailStore(this.detailStoreComponentName)()
    this.storeTable = useTableStore(this.storeName)()
    this.storeTable.headers = this.headers || [
      {text: 'Task', value: 'task_dto', sortable: false, filterable: true, divider: true, width: 25},
      {text: 'Order', value: 'order', sortable: true, filterable: true, divider: true, width: 25, type: 'drag'},
      {
        text: 'Status',
        value: 'row_match_statuses',
        sortable: false,
        filterable: true,
        divider: true,
        align: 'center',
        width: 25,
        type: 'status'
      },
      {
        text: 'Panasonic status',
        value: 'row_panasonic_statuses',
        sortable: false,
        filterable: true,
        divider: true,
        align: 'center',
        width: 25,
        type: 'status'
      },
      {text: 'Edit', value: 'edit', sortable: false, filterable: true, divider: true, width: 25},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Do not place', value: 'do_not_place', sortable: false, filterable: true, divider: true, type: 'bool', width: 10},
      {
        text: 'Provided by customer',
        value: 'provided_by_customer',
        sortable: false,
        filterable: true,
        divider: true,
        type: 'bool',
        width: 10
      },
      {text: 'QTY', value: 'qty', sortable: true, filterable: true, divider: true, align: 'right', width: 50},
      {
        text: 'QTY P&P',
        value: 'quantity_pick_place',
        sortable: true,
        filterable: true,
        divider: true,
        align: 'right',
        width: 50
      },
      {
        text: 'Designator',
        value: 'designator',
        sortable: true,
        align: 'center',
        divider: false,
        width: 250,
        type: "text"
      },
      {text: 'Description', value: 'description', sortable: false, divider: false, width: 250, type: 'text'},
      {text: 'Description', value: 'descriptions_match', sortable: false, divider: false, width: 250, type: 'text'},
      {text: 'Checked', value: 'attributes_checked', sortable: false, divider: true, width: 70, type: 'bool'},
      {text: 'Article parameters', value: 'main_attributes_match', sortable: false, divider: false, width: 250, type: 'text'
      },
      {text: 'MPN', value: 'mpn', sortable: false, align: 'center', divider: false,},
      {text: 'Original article', value: 'article', sortable: false, align: 'right', divider: false, width: 50},
      {text: 'Customer article', value: 'customer_article', sortable: false, align: 'left', divider: true, width: 50},
      {text: '', value: 'component_search', sortable: false, align: 'center', divider: true, width: 80},
      {text: 'Alias', value: 'component__alias', sortable: true, align: 'left', divider: false, width: 250},
      {text: 'Article', value: 'component__article', sortable: true, align: 'left', divider: false, width: 50},
      // {text: 'MPN', value: 'component_mpn', sortable: false, align: 'left', divider: false, width: 200},
      {
        text: 'Type',
        value: 'component__case_package__type',
        sortable: false,
        align: 'center',
        divider: false,
        width: 70
      },
      {
        text: 'Category',
        value: 'component__subcategory__category__category',
        sortable: false,
        align: 'center',
        divider: false,
        width: 100
      },
      {
        text: 'Case Package',
        value: 'component__case_package__name',
        sortable: false,
        align: 'center',
        divider: false,
        width: 80
      },
      {text: 'Image', value: 'component__image', sortable: false, align: 'center', divider: false, width: 60},
      {
        text: 'DSh',
        value: 'component__datasheet',
        sortable: false,
        align: 'center',
        divider: false,
        width: 20,
        type: 'link'
      },

      {text: 'Edited by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'Edited on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'Created by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'Created on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'Saved', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
    }
  },

  data() {
    return {
      storeTable: null,
      detailStoreComponent: null,
      detailStoreComponentName: uuidv4(),
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>